import { Stack } from '@mui/material'
import { useContext } from 'react'
import { Link } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { AuthContext } from '../../providers'
import { CreateButton } from '../AppHeader'
import { NotificationBadge } from '../NotificationBadge/NotificationBadge'
import { UserMenu } from '../UserMenu'

export const AuthNav = () => {
  const { currentUser } = useContext(AuthContext)

  return (
    <>
      {currentUser ? (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}>
          <CreateButton />
          <NotificationBadge />
          <UserMenu currentUser={currentUser} />
        </Stack>
      ) : (
        <Link to={AppRoutes.LOGIN}>Sign In</Link>
      )}
    </>
  )
}
